import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Config } from './config'
import { Plugin } from './plugin'

/**
 * {@link ec.plugins.Plugin.Factory} for this {@link Plugin}
 */
export class Factory<TTypeParams extends ec.models.TypeParams.Constraint>
  implements
    ec.plugins.Plugin.Factory<
      TTypeParams,
      typeof Plugin.id,
      Plugin<TTypeParams>
    >
{
  /** @see {@link ec.plugins.Plugin.Factory.id} */
  public readonly id = Plugin.id

  constructor(private readonly _config: Config.SemiOptional<TTypeParams>) {}

  /** @see {@link ec.plugins.Plugin.Factory.produceFor} */
  public produceFor(
    collection: ec.Collection<TTypeParams>,
  ): Plugin<TTypeParams> {
    return new Plugin({ config: this._config, collection })
  }
}
